module.exports = __webpack_public_path__ + "img/IT0000123671402.e7ee1845.png";